import { isDutyVat } from './invoiceCategory'

// Gary's rule (2026-09-28): a Duty & VAT invoice is due the same day it's issued (paying HMRC
// duty/VAT can't wait on a customer's own payment terms); every other invoice category follows the
// customer's payment_terms text, defaulting to 30 days when it can't be parsed as a number --
// customers.payment_terms is free text (e.g. "NET 30", "30DAY", "COD"), no structured day-count
// column exists anywhere in the schema.
export function parsePaymentTermsDays(paymentTerms: string | null | undefined): number {
  if (!paymentTerms) return 30
  const match = paymentTerms.match(/(\d+)/)
  return match ? parseInt(match[1], 10) : 30
}

export function computeInvoiceDueDate(invoiceDateISO: string, invoiceCategory: string | null, paymentTerms: string | null | undefined): string {
  const dateOnly = invoiceDateISO.slice(0, 10)
  if (isDutyVat(invoiceCategory)) return dateOnly
  const invoiceDate = new Date(dateOnly + 'T00:00:00')
  const days = parsePaymentTermsDays(paymentTerms)
  return new Date(invoiceDate.getTime() + days * 86400000).toISOString().slice(0, 10)
}
